import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IconModule } from '../icon/icon.module';
import { CollapseHeaderDirective } from './collapse-header.directive';
import { CollapseComponent } from './collapse/collapse.component';
import { CollapseGroupComponent } from './collapse-group/collapse-group.component';
import { CollapseInfoWidgetComponent } from './collapse-info-widget/collapse-info-widget.component';


@NgModule({
  imports: [CommonModule, IconModule],
  declarations: [
    CollapseHeaderDirective,
    CollapseGroupComponent,
    CollapseComponent,
    CollapseInfoWidgetComponent,
  ],
  exports: [
    CollapseHeaderDirective,
    CollapseGroupComponent,
    CollapseComponent,
    CollapseInfoWidgetComponent,
   ],
  providers: []
})
export class CollapseModule { }
